import React from "react";

const CampaignIcon = ({ width = 24, height = 24 }) => {
  return (
    <svg
      width={width + ""}
      height={height + ""}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.047 15.8772C9.97419 15.8772 9.90579 15.8572 9.84619 15.8232L14.0822 11.5876L15.0926 12.3224C15.2866 12.5108 15.5422 12.614 15.8146 12.614C16.087 12.614 16.3426 12.5104 16.5366 12.3224L17.547 11.5876L21.783 15.8236C21.7238 15.8576 21.6554 15.8776 21.5822 15.8776H10.047V15.8772Z"
        stroke="#F9C438"
        stroke-miterlimit="10"
      />
      <path
        d="M13.7762 11.3648L9.64378 15.4972C9.64338 15.4892 9.64258 15.4812 9.64258 15.4728V8.35962L13.7762 11.3652V11.3648Z"
        stroke="#F9C438"
        stroke-miterlimit="10"
      />
      <path
        d="M21.8112 8.02442L16.3056 12.0276L16.2936 12.0364L16.2832 12.0468C16.1588 12.1712 15.9924 12.2396 15.8148 12.2396C15.6372 12.2396 15.4708 12.1712 15.3464 12.0468L15.336 12.0364L9.81836 8.02442C9.88356 7.97922 9.96236 7.95282 10.0472 7.95282H21.582C21.6668 7.95282 21.7456 7.97962 21.8108 8.02442H21.8112Z"
        stroke="#F9C438"
        stroke-miterlimit="10"
      />
      <path
        d="M21.9866 15.4724C21.9866 15.4808 21.9858 15.4888 21.9854 15.4968L17.853 11.3644L21.9866 8.35883V15.4724Z"
        stroke="#F9C438"
        stroke-miterlimit="10"
      />
      <path
        d="M13.3337 6.0116H3.16369C2.67769 6.0116 2.28369 6.4056 2.28369 6.8916V13.2072C2.28369 13.6932 2.67769 14.0872 3.16369 14.0872H4.80729C4.55049 15.5616 4.12369 16.8192 3.84249 17.5492C3.78249 17.7044 3.88929 17.888 3.98249 17.7908C5.44009 16.27 6.46609 15.0568 7.18009 14.0872H13.3341C13.8201 14.0872 14.2141 13.6932 14.2141 13.2072V6.8916C14.2141 6.4056 13.8201 6.0116 13.3341 6.0116H13.3337Z"
        stroke="#215E9B"
        stroke-miterlimit="10"
      />
    </svg>
  );
};

export default CampaignIcon;
